import React from 'react';
import Spinner from '@shape-construction/arch-ui/src/Spinner';
import { cn } from '@shape-construction/arch-ui/src/utils/classes';

export interface LoadingSpinnerProps {
  variant?: 'screen';
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ variant }) => {
  return (
    <div
      className={cn('h-full w-full flex items-center justify-center', { 'fixed inset-0': variant === 'screen' })}
      data-testid="loading-spinner"
    >
      <Spinner size="lg" />
    </div>
  );
};
